module.exports = __webpack_public_path__ + "static/media/sparkle@2x.f79c84cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sparkle@2x.png
// module id = 124
// module chunks = 0